import { ChangeEvent, useId, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useChangeCurrencyMode } from "src/api/client/change-currency-mode";
import { WfNativeSelect } from "src/components-mui/base/wf-native-select/wf-native-select";
import { getGlobals } from "src/constants/globals";
import { IFooter } from "src/types/layout";
import { FOOTER_SELECT_CURRENCY_TEST_ID } from "./currency-selector.test-ids";

interface ICurrencySelectorProps {
    currencies: IFooter["currencies"];
}

export const CurrencySelector = ({ currencies }: ICurrencySelectorProps) => {
    const router = useRouter();
    const id = useId();
    const [selectedCurrency, setSelectedCurrency] = useState<string>(() => getGlobals().currency);
    const { t } = useTranslation("common");

    const changeCurrency = useChangeCurrencyMode({
        onSuccess: router.reload,
        onError: router.reload,
    });

    const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setSelectedCurrency(value);
        changeCurrency({ currency: value });
    };

    return (
        <WfNativeSelect
            id={id}
            name={`currency-select-${id}`}
            size="small"
            value={selectedCurrency}
            onChange={onChange}
            data-test-id={FOOTER_SELECT_CURRENCY_TEST_ID}
            aria-label={t("labels.select-currency")}
            inputSx={{ backgroundColor: "transparent", height: "40px !important", lineHeight: theme => theme.spacing(3) }}
            sx={{
                fontSize: theme => theme.typography.sm,
                fontWeight: theme => theme.typography.fontWeightSemibold,
                backgroundColor: "transparent",
                "& .MuiNativeSelect-select": {
                    borderColor: "gray.800",
                },
            }}
        >
            {currencies.map(currency => (
                <option key={currency.value} value={currency.value}>
                    {currency.label}
                </option>
            ))}
        </WfNativeSelect>
    );
};
